<template>
    <div
            class="modal fade"
            id="show_ammeter_graph"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h4 class="modal-title" id="myModalLabel">电表拓扑图</h4>
                </div>
                <!-- modal-body-->
                <div class="modal-body" style="min-width:950px;height:620px;">
                    <div id="amapcontainer" style="width:50%;height:600px;float:left;"></div>
                    <div id="main" style="width:450px;height:600px;float:left;"></div>
                </div>
                <!-- modal-footer -->
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
                    <!-- <button type="button" data-dismiss="modal" class="btn btn-primary">ËÑË÷</button> -->
                </div>
            </div>
        </div>
        <v-ammeterEdit :msg-ammeterid="ammeterid" ref="ammeterEdit"></v-ammeterEdit>
    </div>
</template>
<script>
  import AMap from 'AMap'
  import ammeterEdit from '../ammeter/ammeterEdit'

  var map
  var infoWindow
  var nodes = []
  var links = []
  var charts = { nodes: [], links: [] }
  var option = {}
  var myChart
  option = {
    backgroundColor: '#ffffff',
    title: {
      text: '',
      textStyle: {
        fontWeight: 'normal',
        color: 'rgb(255,224,0)'
      }
    },
    tooltip: {
      formatter: function (x) {
        return x.data.name
      }
    },
    series: [
      {
        type: 'graph',
        layout: 'force',
        symbolSize: 50,
        edgeSymbol: ['circle', 'arrow'],
        force: {
          repulsion: 1000,
          edgeLength: [150, 200],
          layoutAnimation: false
        },
        draggable: true, //节点是否可拖拽
        edgeLabel: {
          normal: {
            show: true,
            formatter: function (x) {
              return x.data.name
            }
          }
        },
        label: {
          normal: {
            show: true,
            position: 'bottom',
            color: '#666666'
          }
        },
        lineStyle: {
          normal: {
            width: 2,
            shadowColor: 'none'
          }
        },
        data: '',
        links: '',
        itemStyle: {
          normal: {
            label: {
              show: true,
              formatter: function (item) {
                console.log('item', item)
                if (item.data.name == '供电局') {
                  return '供电局'
                } else if (item.data.name.indexOf('ammeter') > -1) {
                  var position = item.data.name.split(' ')[1],
                    number = item.data.name.split(' ')[2],
                    model = item.data.name.split(' ')[3]
                  position == 'null' ? (position = '-') : null
                  number == 'null' ? (number = '暂无电表编号') : null
                  model == 'null' ? (model = '非智能表') : null
                  return position + '/' + number + '/' + model
                } else {
                  var name = item.data.name.split(' ')[1],
                    type = item.data.name.split(' ')[2]
                  type ? type = '/' + type : type = ''
                  return name + type
                }
              }
            }
          }
        }
      }
    ]
  }
  export default {
    data () {
      return {
        ammeterid: '' // 电表id
      }
    },
    props: ['msgStationid'],
    components: {
      'v-ammeterEdit': ammeterEdit
    },
    mouted: function () {
      var self = this
    },
    methods: {
      getData: function () {
        var self = this
        infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, 0) })
        myChart = self.echarts.init(document.getElementById('main'))
        self.global.axiosGet(
          self,
          'station/' + self.msgStationid + '/topology/',
          function (res) {
            self.showDataOnMap(res) // 在地图上显示基站
            self.showEcharts(res) // 显示拓扑图
            //点击电表图标修改电表信息
            myChart.on('click', self.myChartClick)
          }
        )
      },
      myChartClick: function (param) {
        var self = this
        if (param.name.indexOf('ammeter') != -1) {
          console.log('修改电表信息')
          var ammeterid = param.name.split(' ')[0]
          self.ammeterid = ammeterid
          console.log(self.ammeterid)
          $('#sys_ammeterEdit_modal').modal('show')
          setTimeout(function () {
            self.$refs['ammeterEdit'].getData() // 调用子组件函数
          }, 1000)
        }
      },
      // 在地图上显示数据
      showDataOnMap: function (data) {
        var self = this
        // console.log("showDataOnMap", data);
        //创建地图
        map = new AMap.Map('amapcontainer', {
          resizeEnable: true,
          zoom: 16,
          // layers: [new AMap.TileLayer.Satellite()],
          center: [116.480373, 39.994144],
          expandZoomRange: true,
          zooms: [3, 20]
        })
        var station_info = data.station_info
        var master = data.master
        var slave = data.slave

        // 显示基站
        var stationMarkers = []
        for (var key in station_info) {
          var stst_longitude = station_info[key].stst_longitude
          var stst_latitude = station_info[key].stst_latitude
          map.setCenter([stst_longitude, stst_latitude])
          var iconPath = ''
          switch (station_info[key].stst_comm) {
            case '中国联通':
              iconPath = '/static/icon_unicom_40.png'
              break
            case '中国移动':
              iconPath = '/static/icon_cmcc_40.png'
              break
            case '中国电信':
              iconPath = '/static/icon_telecom_40.png'
              break
            case '中国铁塔':
              iconPath = '/static/icon_tower_40.png'
              break
            default:
              iconPath = '/static/icon_center.png'
          }

          var stationMarkerContent =
            '<div class="markercontentinfo"><img src=' +
            iconPath +
            '><b>' +
            station_info[key].stst_commname +
            '</b></div>'

          var stationMarker = new AMap.Marker({
            map: map,
            icon: iconPath,
            content: stationMarkerContent,
            position: [stst_longitude, stst_latitude],
            zIndex: 101,
            size: new AMap.Size(10, 10),
            offset: new AMap.Pixel(-5, -5),
            //允许拖动
            draggable: false,
            //raiseOnDrag:true
            extData: station_info[key]
          })
          stationMarker.on('click', self.stationMarkerClick)
          stationMarkers.push(stationMarker)
        }

        // 显示总表
        if (master) {
          var masterMarkers = []
          for (var i = 0; i < master.length; i++) {
            //   console.log('master',master[i])
            var stam_longitude = master[i].center.split(',')[0]
            var stam_latitude = master[i].center.split(',')[1]
            var masterMarkersContent =
              '<div class="markercontentinfo"><img src="/static/icon_ammeterall.png"><b>' +
              master[i].ammeter_numbering +
              '</b></div>'
            var masterMarker = new AMap.Marker({
              map: map,
              icon: '/static/icon_ammeterall.png',
              // content: masterMarkersContent,
              position: [stam_longitude, stam_latitude],
              zIndex: 101,
              size: new AMap.Size(10, 10),
              offset: new AMap.Pixel(-5, -5),
              extData: master[i]
            })
            masterMarker.on('click', self.ammeterrMarkerClick)
            masterMarkers.push(masterMarker)
          }
        }

        if (slave) {
          //显示分表
          var slaveMarkers = []
          for (var i = 0; i < slave.length; i++) {
            // console.log(slave[i])
            for (var j = 0; j < slave[i].length; j++) {
              var stam_longitude = slave[i][j].center.split(',')[0]
              var stam_latitude = slave[i][j].center.split(',')[1]
              var slaveMarkersContent =
                '<div class="markercontentinfo"><img src="/static/icon_ammeter.png"><b>' +
                slave[i][j].ammeter_numbering +
                '</b></div>'
              var slaveMarker = new AMap.Marker({
                map: map,
                icon: '/static/icon_ammeter.png',
                content: slaveMarkersContent,
                position: [stam_longitude, stam_latitude],
                zIndex: 101,
                size: new AMap.Size(25, 34),
                offset: new AMap.Pixel(-5, -5),
                extData: slave[i][j]
              })
              slaveMarker.on('click', self.ammeterrMarkerClick)
              slaveMarkers.push(slaveMarker)
            }
          }
        }
      },
      stationMarkerClick: function (e) {
        var selectedmark = e.target
        var extData = e.target.getExtData()
        console.log(extData)
        var info = []
        info.push(
          '<div style=\'padding:0px 0px 0px 4px;\'>基站名称: <b>' +
          (extData['stst_commname'] ? extData['stst_commname'] : '-') + '</b>'
        )
        info.push('基站类型: ' + (extData['stst_type'] ? extData['stst_type'] : '-'))
        info.push('分管运营商:' + (extData['stst_subcomm'] ? extData['stst_subcomm'] : ''))
        info.push('基站地址 :' + (extData['stst_address'] ? extData['stst_address'] : '-' + '</div></div>'))
        infoWindow.setContent(info.join('<br/>'))
        infoWindow.open(map, e.target.getPosition())
      },
      ammeterrMarkerClick: function (e) {
        var selectedmark = e.target
        var extData = e.target.getExtData()
        console.log(extData)
        var info = []
        info.push(
          '<div style=\'padding:0px 0px 0px 4px;\'>电表编号: ' +
          extData['ammeter_numbering']
        )
        info.push(
          '电表类型: ' +
          (extData['stam_category'] ? extData['stam_category'] : '未知')
        )
        info.push(
          '电表类型 : ' +
          (extData['model'] ? extData['model'] : '非智能表') +
          '</div>'
        )
        infoWindow.setContent(info.join('<br/>'))
        infoWindow.open(map, e.target.getPosition())
      },
      showEcharts: function (res) {
        // console.log(res);
        nodes = []
        links = []
        charts = { nodes: [], links: [] }

        var master = res.master //总表
        var slave = res.slave // 所有的分表
        var masterid = '' // 总表id;

        // 过滤临时表
        for (var i = 0; i < master.length; i++) {
          if (master[i].stam_category == 'Z') {
            master.splice(i, 1)
            i--
          }
        }

        for (var i = 0; i < slave.length; i++) {
          console.log('slave[i]', slave[i])
          for (var j = 0; j < slave[i].length; j++) {
            console.log('slave[i][j]', slave[i][j])
            if (slave[i][j].stam_category == 'Z') {
              slave[i].splice(j, 1)
              j--
            }
          }
        }

        //显示供电局
        var nodeObj = {}
        nodeObj.img = '/static/power_supply.png'
        nodeObj.name = '供电局'
        nodeObj.x = 50
        nodeObj.y = 200
        nodeObj.fixed = true
        nodes.push(nodeObj)

        //供电局连在总表上的线
        if (master && master.length > 0) {
          var linkObj = {}
          linkObj.source = '供电局'
          linkObj.target =
            master[0].id +
            ' ' +
            master[0].ammeter_numbering +
            ' ' +
            master[0].position +
            ' ' +
            master[0].model +
            ' ammeter' //电表id+电表标号+电表位置+电表型号(是否为智能表)

          linkObj.name = ''
          links.push(linkObj)
        } else if (slave && slave[0][0]) {
          // console.log("----", slave[0]);
          for (var n = 0; n < slave.length; n++) {
            var linkObj = {}
            linkObj.source = '供电局'
            linkObj.target =
              slave[n][0].id +
              ' ' +
              slave[n][0].ammeter_numbering +
              ' ' +
              slave[n][0].stam_category +
              ' ' +
              slave[n][0].model +
              ' ammeter' //电表id+电表标号+电表位置+电表型号(是否为智能表)

            linkObj.name = ''
            // console.log('linkObj',linkObj)
            links.push(linkObj)
          }
        }

        // 格式化总表数据
        if (master) {
          for (var i = 0; i < master.length; i++) {
            var nodeObj = {}
            nodeObj.img = '/static/icon_ammeterall.png'
            nodeObj.name =
              master[i].id +
              ' ' +
              master[i].ammeter_numbering +
              ' ' +
              master[i].position +
              ' ' +
              master[i].model +
              ' ' +
              'ammeter'
            masterid =
              master[i].id +
              ' ' +
              master[i].ammeter_numbering +
              ' ' +
              master[i].position +
              ' ' +
              master[i].model +
              ' ammeter'
            nodeObj.x = 150 + 100 * i
            nodeObj.y = 200
            nodeObj.fixed = true
            nodes.push(nodeObj)
            // 如果有多个总表 显示总表间的连线
            if (i > 0) {
              var linkObj = {}
              linkObj.source =
                master[i - 1].id +
                ' ' +
                master[i - 1].ammeter_numbering +
                ' ' +
                master[i - 1].position +
                ' ' +
                master[i].model +
                ' ammeter'
              linkObj.target =
                master[i].id +
                ' ' +
                master[i].ammeter_numbering +
                ' ' +
                master[i].position +
                ' ' +
                master[i].model +
                ' ammeter' //电表id+电表标号+电表位置+电表型号(是否为智能表)
              linkObj.name = ''
              links.push(linkObj)
            }
          }
        }

        // console.log('总表id',masterid);
        var stationAmmeter = [] // 末尾电表id,用于连接基站

        //如果没有子表,基站直接连总表
        if (slave[0].length === 0 && master && master.length > 0) {
          stationAmmeter.push(master[master.length - 1])
        }

        //如果有总表,格式化分表数据
        for (var i = 0; i < slave.length; i++) {
          for (var j = 0; j < slave[i].length; j++) {
            var linkObj = {}
            var nodeObj = {}
            if (j == 0) {
              linkObj.source = masterid
              linkObj.target =
                slave[i][0].id +
                ' ' +
                slave[i][0].ammeter_numbering +
                ' ' +
                slave[i][0].stam_category +
                ' ' +
                slave[i][0].model +
                ' ammeter'
              linkObj.name = ''
              console.log('linkObj', linkObj)
              links.push(linkObj)
              nodeObj.img = '/static/icon_ammeter.png'
              nodeObj.name =
                slave[i][0].id +
                ' ' +
                slave[i][0].ammeter_numbering +
                ' ' +
                slave[i][0].stam_category +
                ' ' +
                slave[i][0].model +
                ' ' +
                'ammeter'
              nodeObj.x = 200 + 100 * i
              nodeObj.y = 200 * i
              nodeObj.fixed = true
              nodes.push(nodeObj)
            } else {
              linkObj.source =
                slave[i][j - 1].id +
                ' ' +
                slave[i][j - 1].ammeter_numbering +
                ' ' +
                slave[i][j - 1].stam_category +
                ' ' +
                slave[i][j - 1].model +
                ' ammeter'
              linkObj.target =
                slave[i][j].id +
                ' ' +
                slave[i][j].ammeter_numbering +
                ' ' +
                slave[i][j].stam_category +
                ' ' +
                slave[i][j].model +
                ' ammeter'
              linkObj.name = ''
              links.push(linkObj)
              nodeObj.img = '/static/icon_ammeter.png'
              nodeObj.name =
                slave[i][j].id +
                ' ' +
                slave[i][j].ammeter_numbering +
                ' ' +
                slave[i][j].stam_category +
                ' ' +
                slave[i][j].model +
                ' ammeter'
              nodeObj.x = 400 + 100 * j
              nodeObj.y = 200 * i
              nodeObj.fixed = true
              nodes.push(nodeObj)
            }
            // 填充末尾电表id
            if (j === slave[i].length - 1) {
              stationAmmeter.push(slave[i][j])
            }
          }
        }

        console.log('---', stationAmmeter)
        // console.warn(nodes,links);

        var station_info = res.station_info

        //在关系图末尾插入基站
        for (var i = 0; i < stationAmmeter.length; i++) {
          //从电表id指向基站id
          var linkObj = {}
          var nodeObj = {}
          linkObj.source =
            stationAmmeter[i].id +
            ' ' +
            stationAmmeter[i].ammeter_numbering +
            ' ' +
            stationAmmeter[i].stam_category +
            ' ' +
            stationAmmeter[i].model +
            ' ammeter'
          console.log(linkObj.source)
          linkObj.target =
            station_info[stationAmmeter[i].station_id].stst_atpid +
            ' ' +
            station_info[stationAmmeter[i].station_id].stst_commname +
            ' ' +
            station_info[stationAmmeter[i].station_id].stst_type +
            ' '
          // console.log("~~~", linkObj.target);
          linkObj.name = ''
          links.push(linkObj)
          nodeObj.x = 400 + 100 * i
          if (i == 0) nodeObj.x = 400
          nodeObj.y = 70 + 250 * i // 基站id+基站名称+基站类型
          nodeObj.fixed = true
          nodeObj.name =
            station_info[stationAmmeter[i].station_id].stst_atpid +
            ' ' +
            station_info[stationAmmeter[i].station_id].stst_commname +
            ' ' +
            station_info[stationAmmeter[i].station_id].stst_type +
            ' ' //

          switch (station_info[stationAmmeter[i].station_id].stst_comm) {
            case '中国移动': {
              nodeObj.img = '/static/icon_cmcc_40.png'
              break
            }
            case '中国电信': {
              nodeObj.img = '/static/icon_telecom_40.png'
              break
            }
            case '中国联通': {
              nodeObj.img = '/static/icon_unicom_40.png'
              break
            }
            case '中国铁塔': {
              nodeObj.img = '/static/icon_tower_40.png'
              break
            }
            default: {
              nodeObj.img = '/static/icon_map_07.png'
            }
          }

          nodes.push(nodeObj)
        }

        console.warn(nodes, links)

        for (var j = 0; j < nodes.length; j++) {
          var node = {
            name: nodes[j].name,
            alarm: nodes[j].alarm,
            symbol: 'image://' + nodes[j].img,
            symbolSize: [30, 30],
            fixed: nodes[j].fixed,
            x: nodes[j].x,
            y: nodes[j].y,
            itemStyle: {
              normal: {
                color: 'none'
              }
            }
          }
          charts.nodes.push(node)
        }
        for (var i = 0; i < links.length; i++) {
          var link = {
            source: links[i].source,
            target: links[i].target,
            label: {
              normal: {
                show: true,
                formatter: links[i].name
              }
            },
            lineStyle: {
              normal: {
                color: '#17FFF3'
              }
            }
          }
          charts.links.push(link)
        }

        // 使用刚指定的配置项和数据显示图表。
        option.series[0].data = charts.nodes
        option.series[0].links = charts.links
        myChart.setOption(option, true)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/stationmanager/ammetergraph.vue